import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './CardGrid.css';
import { useNavigate } from 'react-router-dom';
import CommonCalls from '../CommonAPICalls/CommonCalls';

function CardGrid() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const navigate = useNavigate();

  const apiCall = new CommonCalls();

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await apiCall.getBlogsItems(pageNumber,9);
        setBlogs(response.blogs || response?.data);
        setTotalRecords(response?.total_records)
      } catch (error) {
        console.error('Error fetching blogs:', error);
        setError('Error fetching blogs');
      }
      setLoading(false);
    };

    fetchBlogs();
  }, [pageNumber]);

  const stripHtml = (html) => {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  };

  const truncateContent = (content, maxWords) => {
    const plainTextContent = stripHtml(content);
    const words = plainTextContent.split(' ');
    if (words.length > maxWords) {
      return words.slice(0, maxWords).join(' ') + '...';
    }
    return plainTextContent;
  };

  const redirectUserToBlog = (blog_slug_url) => {
    if (!blog_slug_url) return;
    navigate(`/blog/${blog_slug_url}`);
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className='outside'>
      <Container className='main-cardgrid'>
        <Row>
          {blogs.length > 0 ? (
            blogs.map((blog) => (
              <Col sm={12} md={6} lg={4} key={blog._id} className="mb-4">
                <Card style={{ border: 'none' }}>
                  <Card.Img variant="top" src={blog.image || '/images/creatives/cards.jpg'} />
                  <Card.Body className='card-body'>
                    <Card.Title className='card-title'>{blog.blog_title}</Card.Title>
                    <p
                      className='para_main'
                      dangerouslySetInnerHTML={{ __html: truncateContent(blog.blog_content, 20) }}
                    />
                    <Card.Link className='href' onClick={() => { redirectUserToBlog(blog.blog_slug_url) }}>Read More →</Card.Link>
                  </Card.Body>
                </Card>
              </Col>
            ))
          ) : (
            <Col>
              <div>No blogs available</div>
            </Col>
          )}
        </Row>
      </Container>
      <div className='pagination-btn d-flex justify-content-center align-items-center gap-4 mt-3'>
          {
                  pageNumber !==1 ?
                  <img onClick={() => setPageNumber(prev => (prev > 1 ? prev - 1 : prev))} src='/images/icons/arrow-icon.png' alt='arrow icon' style={{width:"35px",borderRadius:"50%",padding:"10px",background:"grey",cursor:"pointer"}} />
                  :
                  <img src='/images/icons/arrow-icon.png' alt='arrow icon' style={{width:"35px",borderRadius:"50%",padding:"10px",background:"#E2E2E2",cursor:"not-allowed"}} />
          }
          
          {totalRecords> (pageNumber * 9)?
          <img onClick={()=>{setPageNumber((prev)=>{return prev+=1 })}} src='/images/icons/arrow-icon.png' alt='arrow icon' style={{width:"35px",borderRadius:"50%",padding:"10px",background:"grey",transform:"rotate(180deg)",cursor:"pointer"}} />
          :
          <img src='/images/icons/arrow-icon.png' alt='arrow icon' style={{width:"35px",borderRadius:"50%",padding:"10px",background:"#E2E2E2",transform:"rotate(180deg)",cursor:"not-allowed"}} />
          }
      </div>
    </div>
  );
}

export default CardGrid;
